"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var RequestEpicDescriptor =
/*#__PURE__*/
function () {
  function RequestEpicDescriptor(options) {
    (0, _classCallCheck2.default)(this, RequestEpicDescriptor);

    if (!options.apiFunction) {
      throw new Error('Cannot create action descriptor without apiFunction!');
    }

    if (!options.initiatingActionType) {
      throw new Error('Cannot create action descriptor without initiatingActionType!');
    }

    if (!options.requestStatusSelector) {
      throw new Error('Cannot create action descriptor without requestStatusSelector!');
    }

    if (!options.requestStatusTypeFilters) {
      throw new Error('Cannot create action descriptor without requestStatusTypeFilter!');
    }

    if (!options.requestActions) {
      throw new Error('Cannot create action descriptor without requestActions!');
    }

    this.apiFunction = options.apiFunction;
    this.initiatingActionType = options.initiatingActionType;
    this.requestStatusSelector = options.requestStatusSelector;
    this.requestStatusTypeFilters = options.requestStatusTypeFilters;
    this.requestActions = options.requestActions;
    this.sc404isSuccess = options.sc404isSuccess || false; // Set this to true if 404 status codes should be treated as successful responses

    this.getAdditionalParamsFromState = options.getAdditionalParamsFromState || function () {}; // any additional params to pass to the api call from state

  }

  (0, _createClass2.default)(RequestEpicDescriptor, [{
    key: "makeAPICall",
    value: function makeAPICall() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var additionalParams = arguments.length > 1 ? arguments[1] : undefined;
      return this.apiFunction(data, additionalParams);
    }
  }, {
    key: "getInitiatingActionType",
    value: function getInitiatingActionType() {
      return this.initiatingActionType;
    }
  }, {
    key: "getRequestStatusTypeFilters",
    value: function getRequestStatusTypeFilters() {
      return this.requestStatusTypeFilters;
    }
  }, {
    key: "getRequestStatus",
    value: function getRequestStatus(state) {
      return this.requestStatusSelector(state);
    }
  }, {
    key: "getRequestAction",
    value: function getRequestAction() {
      return this.requestActions.request;
    }
  }, {
    key: "getSuccessAction",
    value: function getSuccessAction() {
      return this.requestActions.success;
    }
  }, {
    key: "getFailureAction",
    value: function getFailureAction() {
      return this.requestActions.failure;
    }
  }]);
  return RequestEpicDescriptor;
}();

exports.default = RequestEpicDescriptor;
module.exports = exports.default;